import { DisciplineAction, DisciplineActionTypes } from '@completion/actions';
import { Discipline, byDisciplineNumber } from '@completion/models';

export interface DisciplineState {
  disciplines: Discipline[];
}

export const initialState: DisciplineState = {
  disciplines: [],
};

export function disciplineReducer(state: DisciplineState = initialState, action: DisciplineAction): DisciplineState {
  switch (action.type) {
    case DisciplineActionTypes.DisciplineLoadSuccess:
      return {
        ...state,
        disciplines: [...action.disciplines].sort(byDisciplineNumber),
      };
    default:
      return state;
  }
}
